import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingContainer from "@/components/onboarding/OnboardingContainer/OnboardingContainer.vue";
import { useGetOnboardingTransferContactsProperties } from "./useGetOnboardingTransferContactsProperties";


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingTransferContacts',
  setup(__props) {

const { transferContactsProperties } =
  useGetOnboardingTransferContactsProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingContainer, _normalizeProps(_guardReactiveProps(_unref(transferContactsProperties))), null, 16))
}
}

})